import { languages } from '@adjust/dashboard-core/lib/constants/languages';

function userDetailsFields() {
  'ngInject';
  return {
    restrict: 'E',
    scope: {},
    template: require('./user-details-fields.html'),
    controller: 'UserDetailsFieldsController',
    controllerAs: 'vm',
    bindToController: {
      form: '=',
      user: '=',
      isEdit: '='
    }
  };
}

function UserDetailsFieldsController($q, Account, Moment, Helper) {
  'ngInject';
  var vm = this;

  vm.languages = languages;

  Helper.ready(_handleReady);

  /**
   * Handle ready state, when scope is digested
   *
   * @private
   */
  function _handleReady() {

    if (!vm.isEdit) {
      return;
    }

    $q.all([
      Moment.timezones(),
      Account.getCurrent()
    ])
      .then(function(result) {

        vm.timezones = [{id: null, label: 'Default'}].concat(result[0]);

        if (vm.user) {
          vm.user.timezone_id = vm.user.timezone_id || result[1].timezone_id;
        }

      });

  }
}

export { UserDetailsFieldsController, userDetailsFields };
